import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { UsersTableData } from "../../../types/formDataTypes";
import { UserCompact } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { MenuDataTable } from "../../../ui/DataTable/MenuDataTable";
import { SimpleDataTable } from "../../../ui/DataTable/SimpleDataTable";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogOverlay, DialogTitle, DialogTrigger } from "../../../ui/Dialog";
import UserItem from "./userItem/UserItem";
import AddUser from "./AddUser";
import { t } from "i18next";

export default function UsersGrid() {
  const [users, setUsers] = useOutletContext<[UserCompact[], Function]>();
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState()
  const [search, setSearch] = useState("");
  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false)
  const [openEditModal, setOpenEditModal] = useState<boolean>(false)
  
  const divisions = useAppStore().divisions  
  const persons = useAppStore().persons

  let nodes = users?.map((data) => {
    return {
      id: data.id,
      first_name: data.attributes.first_name,
      last_name: data.attributes.last_name,
      middle_name: data.attributes.middle_name,
      email: data.attributes.email,
      status: data.attributes.status,
      division_id: data.attributes.division_id,
      person_id: data.attributes.personnel_id
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => search ? item.last_name?.toLowerCase().includes(search.toLowerCase()) || item.first_name?.toLowerCase().includes(search.toLowerCase()) : true),
  };

  

  const columns: ColumnDef<UsersTableData>[] = [
    {
      header: t("surname"),
      size: 200,
      cell: ({ row }) => row.original.last_name,
      },
    {
      header: t("name"),
      size: 200,
      cell: ({ row }) => row.original.first_name,
    },

    {
      header: t("status"),
      size: 100,
      minSize: 100,
      maxSize: 100,
      cell: ({ row }) => row.original.status,
    },
    {
      header: t("division"),
      size: 1000,
      cell: ({ row }) =>
        row.original.division_id
          ? divisions?.find((division: { id: string; }) => division.id == String(row.original.division_id))?.attributes.name
          : t("all_divisions"),
    },
    {
      header: t("post"),
      size: 1000,
      cell: ({ row }) =>
        row.original.person_id
          ? persons?.find((person) => person.id == String(row.original.person_id))?.attributes.post_name
          : "",
    },
  ];

  function selectUser(item: any) {
    setSelectedUser(item.id)
    setOpenEditModal(true)
  }
  
  function addUser() {
    setOpenCreateModal(true)
  }
    
  return (
    <>
      <div className="flex flex-col w-full">
          <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
              <Input 
                  className="h-8"
                  placeholder={t("search")}
                  onChange={handleSearch}
                  value={search}
                  autoComplete="off"
                  width="100%" 
              />
              
              <RoleRequire role="maintainer">
                <Button variant={"default"} size={"md"} onClick={() => addUser()}>{t("create_participant")}</Button>
              </RoleRequire>
          </div>
      </div>

      {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
      <div className="flex w-full h-full justify-center items-center">
          {t("no_data")}
      </div>
      ) : (
        <SimpleDataTable data={data.nodes} columns={columns} onClickRow={selectUser}/>
      )}
      {openCreateModal && <AddUserDialog open={openCreateModal} onChange={setOpenCreateModal}/>}
      {selectedUser && openEditModal && <EditUserDialog id={selectedUser!} open={openEditModal} onChange={setOpenEditModal}/>}
    </>
  )
}


function AddUserDialog({open, onChange}:{open: boolean, onChange: (state: boolean) => void}) {
  return (
    <Dialog open={open} onOpenChange={() => onChange(!open)}>
      <DialogOverlay className="bg-slate-950/40 data-[state=open]:animate-overlayShow fixed inset-0" />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("adding_participant")}</DialogTitle>
          <DialogDescription>
            {t("adding_participant_desc")}
          </DialogDescription>
          <AddUser />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}

function EditUserDialog({id, open, onChange}:{id: string, open: boolean, onChange: (state: boolean) => void}) {
  return (
    <Dialog open={open} onOpenChange={() => onChange(!open)}>
      <DialogOverlay className="bg-slate-950/40 data-[state=open]:animate-overlayShow fixed inset-0" />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("editing_participant")}</DialogTitle>
          <DialogDescription>
            {t("editing_participant_desc")}
          </DialogDescription>
          <UserItem id={id}/>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}